import { Award, Clock, Sprout, HeartHandshake } from "lucide-react";
import { useT } from "../lib/i18n";

const ICONS = [Sprout, Award, Clock, HeartHandshake];

export default function About() {
  const { t } = useT();
  const values = t("about.values");
  return (
    <section
      id="apropos"
      data-testid="about-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5">
            <div className="text-sm tracking-[0.25em] uppercase text-[#1B5E20] font-medium mb-4">
              {t("about.eyebrow")}
            </div>
            <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-light tracking-tight text-[#1A2E1C] leading-tight">
              {t("about.title1")}{" "}
              <span className="text-[#1B5E20] font-medium">{t("about.title2")}</span>
            </h2>
            <p className="mt-6 text-lg text-[#5C705E] leading-relaxed">
              {t("about.p1")}
            </p>
            <p className="mt-4 text-lg text-[#5C705E] leading-relaxed">
              {t("about.p2")}
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {values.map((v, i) => {
              const Icon = ICONS[i] || Sprout;
              return (
                <div
                  key={v.title}
                  data-testid={`value-card-${i}`}
                  className="bg-white rounded-3xl p-7 border border-[#E5EBE5] hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-2xl bg-[#E8F5E9] flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-[#1B5E20]" />
                  </div>
                  <h3 className="font-['Outfit'] text-xl font-semibold text-[#1A2E1C] mb-2">
                    {v.title}
                  </h3>
                  <p className="text-[#5C705E] leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
